import React from 'react';
import { ResponsiveImage, ResponsiveImageSize } from 'react-responsive-image';

const OurTeam = () => {
    return (
        <section id="our-team" className="bg-gray-light spacer p-top-xl p-bottom-m">
            <div className="wrapper">
                <div className="row gutter-width-md with-pb-md">
                    <div className="col-sm-12 col-md-5 col-lg-5 col-xl-5">
                        <div className="title text-max-width">
                            <h2>Physiotherapist</h2>
                        </div>

                        <div>
                            <div className="signature spacer m-top-xs">
                                <div className="profile-img">
                                    <ResponsiveImage>
                                        <ResponsiveImageSize
                                            default
                                            minWidth={0}
                                            path={"assets/img/home/JuliaSmall.jpg"}
                                        />
                                        <ResponsiveImageSize
                                            minWidth={768}
                                            path={"assets/img/home/JuliaXS.jpg"}
                                        />
                                        <ResponsiveImageSize
                                            minWidth={830}
                                            path={"assets/img/home/JuliaSmall.jpg"}
                                        />
                                        <ResponsiveImageSize
                                            minWidth={940}
                                            path={"assets/img/home/JuliaMedium.jpg"}
                                        />
                                        <ResponsiveImageSize
                                            minWidth={1200}
                                            path={"assets/img/home/JuliaLarge.jpg"}
                                        />
                                        <ResponsiveImageSize
                                            minWidth={1400}
                                            path={"assets/img/home/JuliaLarge.jpg"}
                                        />
                                    </ResponsiveImage>
                                </div>
                            </div>
                        </div>
                    </div>
                

                    <div className="col-sm-12 col-md-7 col-lg-7 col-xl-7">
                        <div className="description-2">
                            <p>
                                Gaining her BSc Physiotherapy in Edinburgh, Julia’s comprehensive experience in both hospital and private practice 
                                senior roles is formidable. Earlier in her career she was physio to a large UK rugby club and worked at sports injury
                                clinics. She travelled and worked in hospital physio roles in both Australia and New Zealand for 2 years. After which
                                she worked in a private practice clinic in central London for over 10 years. When Julia returned to New Zealand again,
                                married with young children she became a Director/ Joint Owner and Musculoskeletal Physiotherapist at Ultimate Physio, 
                                a private practice for 14 years. As well as keeping up to date with the latest physiotherapy hands on techniques, Julia
                                has been using acupuncture and advanced dry needling to complement her practice for over 20 years. In 2019, she gained
                                her postgraduate at AUT in evidence based Western Medical Acupuncture. She uses this holistic approach combined with
                                exercise and advice to gain optimum results for her clients. Julia enjoys keeping herself fit by walking her dogs, 
                                doing yoga, pilates and using the gym. She loves exploring NZ doing tramps and planning travels to other countries. 
                                She supports and travels with her husband, a world champion Aquabiker when he competes and represents New Zealand at 
                                the World Triathlon championships. 
                            </p>
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurTeam;
